import { NgModule } from '@angular/core';
import { ClockPipe } from './clock';
import { CnpjPipe } from './cnpj';
import { CpfPipe } from './cpf';
import { DatePipe } from './date';
import { NormalizePipe } from './normalize';
import { NumberPipe } from './number';
import { SanitizePipe } from './sanitize';
import { TimePipe } from './time';
import { TranslatePipe } from './translate';

export const CUSTOM_PIPES = [ClockPipe, CnpjPipe, CpfPipe, DatePipe, NormalizePipe, NumberPipe, SanitizePipe, TimePipe, TranslatePipe];

@NgModule({
  imports: [CUSTOM_PIPES],
  exports: [CUSTOM_PIPES],
})
export class PipesModule {}
